export default __webpack_public_path__ + "static/media/Pre-loaded.4343a010.svg";